import {CurrentModuleId} from "./CurrentModuleId";
import {CreateSelfcareSouscriptionActions} from "./SouscriptionSelfcare/CreateSelfcareSouscriptionActions";
import {CreateCGPSouscriptionActions} from "./SouscriptionCGP/CreateCGPSouscriptionActions";

export const CreateSouscriptionActions = {
     CREATE_SOUSCRIPTION_PAGE_LOADED_ACTION : { type : 'SouscriptionSuiviActions.CREATE_SOUSCRIPTION_PAGE_LOADED_ACTION', build : () => {return {type: CreateSouscriptionActions.CREATE_SOUSCRIPTION_PAGE_LOADED_ACTION.type, payload:{}}}},
    SELECT_MODULE_TO_DISPLAY_ACTION : { type : 'SouscriptionSuiviActions.SELECT_MODULE_TO_DISPLAY_ACTION', build : (moduleId: CurrentModuleId) => {return {type: CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type, payload:{moduleId}}}},
    ...CreateSelfcareSouscriptionActions,
    ...CreateCGPSouscriptionActions,
};
